/**
 * New Text Levels
 */
export var TextLevels;
(function (TextLevels) {
    TextLevels[TextLevels["ONE"] = 1] = "ONE";
    TextLevels[TextLevels["TWO"] = 2] = "TWO";
    TextLevels[TextLevels["THREE"] = 3] = "THREE";
    TextLevels[TextLevels["FOUR"] = 4] = "FOUR";
})(TextLevels || (TextLevels = {}));
/**
 * List of available Markup for Text
 */
export var TextMarkup;
(function (TextMarkup) {
    TextMarkup["P"] = "p";
    TextMarkup["SPAN"] = "span";
})(TextMarkup || (TextMarkup = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL3RleHQvVGV4dEVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxVQUtYO0FBTEQsV0FBWSxVQUFVO0lBQ3BCLHlDQUFPLENBQUE7SUFDUCx5Q0FBTyxDQUFBO0lBQ1AsNkNBQVMsQ0FBQTtJQUNULDJDQUFRLENBQUE7QUFDVixDQUFDLEVBTFcsVUFBVSxLQUFWLFVBQVUsUUFLckI7QUFPRDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFVBR1g7QUFIRCxXQUFZLFVBQVU7SUFDcEIscUJBQU8sQ0FBQTtJQUNQLDJCQUFhLENBQUE7QUFDZixDQUFDLEVBSFcsVUFBVSxLQUFWLFVBQVUsUUFHckIifQ==